import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function CCD_FAQ_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='mt-5'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-5'>Describe the types of Data Structures?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          The following are the forms of records structures:
          <br></br>   
          <ul>
            <li>Lists: a collection of related matters related to the preceding or/and following statistics objects.</li>
            <li>Arrays: a collection of values which can be all the same.</li>
            <li>Data: a collection of fields, each of which incorporates records from a single statistics type.</li>
            <li>Timber: A facts structure that organizes data in a hierarchical framework. This form of data structure follows the ordered order of facts item insertion, deletion, and change.</li>
            <li>Tables: The information is stored within the form of rows and columns. These are similar to statistics in that the final results or alteration of records is mirrored throughout the complete desk.</li>
          </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>What is a Linear Data Structure? Name a few examples.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          A data structure is linear if all its elements or data items are arranged in a sequence or a linear order. The elements are stored in a non-hierarchical way so that each item has successors and predecessors except the first and last element in the list.
          <br></br>Examples of linear data structures are Arrays, Stack, Strings, Queue, and Linked List.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>What is the difference between file structure and storage structure?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          The difference lies within the memory location accessed. Storage structure refers to the information structure within the reminiscence of the pc machine, whereas report shape represents the storage structure in the auxiliary reminiscence.
          </Typography>
        </AccordionDetails>
      </Accordion>

    </div>
    </div>
  );
}
